import { render, staticRenderFns } from "./audioreading.vue?vue&type=template&id=36e9ef56&scoped=true&"
import script from "./audioreading.vue?vue&type=script&lang=js&"
export * from "./audioreading.vue?vue&type=script&lang=js&"
import style0 from "./audioreading.vue?vue&type=style&index=0&id=36e9ef56&lang=less&scoped=true&"
import style1 from "./audioreading.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e9ef56",
  null
  
)

export default component.exports